import { hasAnyRole } from "@westshorehome/wsh-roles";

// internal Entra role names
const Super_Admin = "_.Admin";
const Carbon_Admin = "Carbon.Admin";
const Carbon_Support = "Carbon.Support";

export type AppSection = {
    name: string;
    roles: Array<string>;
};

export function canSeeSection(section: AppSection) {
    return hasAnyRole(section.roles.concat([Super_Admin]));
}

export const sections = {
    support: { name: "Support", roles: [Carbon_Admin, Carbon_Support] },
    admin: { name: "Admin", roles: [Carbon_Admin] },
};
